/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_History_TitleInputs */

const en_us2_plan_history_title = /** @type {(inputs: Plan_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan history`)
};

const pt_br2_plan_history_title = /** @type {(inputs: Plan_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histórico do plano`)
};

const es_419_plan_history_title = /** @type {(inputs: Plan_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historial del plan`)
};

const pt_pt2_plan_history_title = /** @type {(inputs: Plan_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histórico do plano`)
};

const fr_fr2_plan_history_title = /** @type {(inputs: Plan_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historique du programme`)
};

const de_de2_plan_history_title = /** @type {(inputs: Plan_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planverlauf`)
};

const it_it2_plan_history_title = /** @type {(inputs: Plan_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storico della scheda`)
};

/**
* | output |
* | --- |
* | "Plan history" |
*
* @param {Plan_History_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_history_title = /** @type {((inputs?: Plan_History_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_History_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_history_title(inputs)
	if (locale === "es-419") return es_419_plan_history_title(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_history_title(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_history_title(inputs)
	if (locale === "de-DE") return de_de2_plan_history_title(inputs)
	if (locale === "it-IT") return it_it2_plan_history_title(inputs)
	return en_us2_plan_history_title(inputs)
});
export { plan_history_title as "plan.history_title" }